import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    // url: '/Api/Open/Handle',
    method: 'post',
    data: { 'obj_name': 'check_user_login', 'keyValue': data }
  })
}
export function AccountMenu (data) {
  return request({
    // url: '/Api/Open/Handle',
    method: 'post',
    data: { 'obj_name': 'get_user_menu', 'keyValue': data }
  })
}
export function UpdatePassword (data) {
  return request({
    // url: '/Api/Open/Handle',
    method: 'post',
    data: { 'obj_name': 'update_password', 'keyValue': data }
  })
}
